import { render, staticRenderFns } from "./Falecido.vue?vue&type=template&id=20ce116e&scoped=true&"
import script from "./Falecido.vue?vue&type=script&lang=js&"
export * from "./Falecido.vue?vue&type=script&lang=js&"
import style0 from "./Falecido.vue?vue&type=style&index=0&id=20ce116e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ce116e",
  null
  
)

export default component.exports